/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationPavillonInformationMutation($input: SaveSimulationPavillonInformation_M_simulation_pavillon_informationInput!) {
    saveSimulationPavillonInformation_M_simulation_pavillon_information(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
